import { Component, Input,EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'dskl-menu',
  templateUrl: "menu.component.html"
})
export class MenuComponent { 
    @Input() label="";
    @Output() selected=new EventEmitter();
    @Input() items=[];
    @Input() item:any;
    @Input() up=false;
    
    onSelect(e){
        console.log("Clicked on menu item")
        this.item = e;
        this.selected.next(e);
    }
}



// WEBPACK FOOTER //
// /app/src/app/utils/menu/menu.component.ts